
<script lang="ts">
import { SERVICE_URL } from "../evironment";

import type { AppFileDto } from "../global";
import { getAccessToken } from "../services/session";

export let file: AppFileDto;

function upDateSrc(file: AppFileDto): string{

    let url = new URL(`/api/files/content/${file.id}` , SERVICE_URL);

    if (SERVICE_URL.includes('localhost') ) {
        url = new URL(`/files/content/${file.id}` , SERVICE_URL);
    }

    url.searchParams.set('access_token', getAccessToken());
    
    return url.toString();
}

</script>


<a href='{upDateSrc(file)}' target="_blank">
    {#if file.mimeType.includes('video')}
        <img src={'/icons/avi.svg'}  alt="">
    {:else if file.mimeType.includes('pdf')}
        <img src={'/icons/pdf.svg'}  alt="">
    {:else if file.mimeType.includes('word')}
        <img src={'/icons/doc.svg'}  alt="">
    {:else if file.mimeType.includes('xml') || file.mimeType.includes('xls')}
        <img src={'/icons/xls.svg'}  alt="">
    {:else}
        <img src={upDateSrc(file)}  alt="">
    {/if}
</a>



